import { render, staticRenderFns } from "./EmployeePrivateTable.vue?vue&type=template&id=12683449&scoped=true"
import script from "./EmployeePrivateTable.vue?vue&type=script&lang=js"
export * from "./EmployeePrivateTable.vue?vue&type=script&lang=js"
import style0 from "./EmployeePrivateTable.vue?vue&type=style&index=0&id=12683449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12683449",
  null
  
)

export default component.exports